import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function NoExperienceJobs() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Jobs That Require No Experience (2026 Guide)"
        description="Discover the best jobs that require no experience. Start your career today with these entry-level opportunities and resume tips."
        canonical="https://employpilot.com/no-experience-jobs"
      />

      <h1>Jobs That Require No Experience</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Looking for your first job? These roles require little to no experience
        and are perfect for getting started.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Build Your Resume
      </button>

      <h2 style={{ marginTop: "40px" }}>Top Entry-Level Jobs</h2>

      <ul>
        <li>✔ Customer Service Representative</li>
        <li>✔ Retail Associate</li>
        <li>✔ Warehouse Worker</li>
        <li>✔ Delivery Driver</li>
        <li>✔ Administrative Assistant</li>
      </ul>

      <h2 style={{ marginTop: "40px" }}>Remote Jobs With No Experience</h2>

      <ul>
        <li>✔ Data Entry Clerk</li>
        <li>✔ Virtual Assistant</li>
        <li>✔ Customer Support Agent</li>
      </ul>

      <h2 style={{ marginTop: "40px" }}>How to Get Hired Faster</h2>

      <ul>
        <li>✔ Apply to multiple jobs daily</li>
        <li>✔ Tailor your resume</li>
        <li>✔ Prepare for interviews</li>
      </ul>

      {/* INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        No resume yet?{" "}
        <Link to="/resume-no-experience">
          Learn how to build one
        </Link>
      </p>

      <p>
        Need examples?{" "}
        <Link to="/entry-level-resume-examples">
          See entry-level resumes
        </Link>
      </p>

      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Your Job Search Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>

      <h2 style={{ marginTop: "60px" }}>FAQs</h2>

      <h3>Can I really get hired with no experience?</h3>
      <p>Yes — many jobs are designed for beginners.</p>

      <h3>What industries hire beginners?</h3>
      <p>Retail, logistics, customer service, and admin roles.</p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default NoExperienceJobs;